export const snackBarDisplayTimeInMs = 3500;
export const snackBarErrorDisplayTimeInMs = 8000; // Longer duration for error messages
